import { useMemo } from 'react'
import { useQuery } from '@tanstack/react-query'
import { useSelector } from 'react-redux'
import { contextCompanyIdSelector } from '../../../redux/context/company/selectors'
import { getCompanyGroupOptions } from '../../companyGroup/queries/getCompanyGroupOptions'
import { flattenGroup } from '../../companyGroup/utils/companyGroupUtils'
import { Company } from '../../../types/company/Company'

export const useMappingCompanies = () => {
  const companyId = useSelector(contextCompanyIdSelector)!
  const {
    data: companyGroup,
    isLoading,
    isError,
    refetch
  } = useQuery({
    ...getCompanyGroupOptions(companyId),
    enabled: !!companyId
  })

  // Recursively flattens the whole group tree (subsidiaries of subsidiaries included), same
  // helper the account map page uses for company columns — keeps this feature in sync with it.
  const companies = useMemo(
    () => (companyGroup ? flattenGroup(companyGroup as Company).filter(company => !company.elimination) : []),
    [companyGroup]
  )

  return { groupCompany: companyGroup?.group, companies, isLoading, isError, refetch }
}
